const texts = {
    authorizationTabs: { signIn: "Inloggen", signUp: "Aanmelden" },
    general: {
        save: "Opslaan",
        close: "Sluiten",
        next: "Volgende",
        clearStep: "Deze stap wissen",
        tryAgain: "Opnieuw proberen",
        errorTitle: "Fout",
        service: "Service:",
        message: "Bericht:",
        statusCode: "Statuscode:",
    },
    months: {
        "1": "Januari",
        "2": "Februari",
        "3": "Maart",
        "4": "April",
        "5": "Mei",
        "6": "Juni",
        "7": "Juli",
        "8": "Augustus",
        "9": "September",
        "10": "Oktober",
        "11": "November",
        "12": "December",
    },
    signIn: {
        title: "Welkom bij MultiMatch",
        description: "Creëer uw eigen op maat gemaakte oplossing met Gecontroleerd Vrijkomende Meststoffen",
        email: "E-Mail",
        password: "Wachtwoord",
        forgotPassword: "Wachtwoord vergeten?",
        keepMeLoggedIn: "Houd mij ingelogd op deze computer",
        keepMeLoggedInMobile: "Houd mij ingelogd op dit toestel",
        emailApproved: "Uw e-mail is goedgekeurdlog in om verder te gaan",
    },
    updatePassword: {
        title: "Nieuw wachtwoord instellen",
        description: "Uw wachtwoord moet het volgende bevatten",
        password: "Nieuw wachtwoord",
        confirmPassword: "Wachtwoord bevestigen",
        submitMessage: "Wachtwoord bijwerken",
        success: "Uw wachtwoord is gewijzigd: u wordt omgeleid naar de inlogpagina.",
        UPDATE_PASSWORD_CONFIRMED: "Uw wachtwoord is succesvol bevestigd",
        errors: {
            EMAIL_TOKEN_INVALID: "Uw wachtwoord voldoet niet aan de voorwaarden",
            EMAIL_NOT_CONFIRMED: "Uw emailadres is niet bevestigd.",
            MAIL_NOT_CONFIRMED: "Uw emailadres is niet bevestigd.",
            PASSWORD_UPDATE_SUCCESS: "Uw wachtwoord is bijgewerkt",
            PASSWORD_UPDATE_FAILED: "Uw wachtwoord kan niet worden bijgewerkt",
            TEMP: "Ongeldige token of e-mail niet bevestigd",
        },
        sendEmail: "We hebben een e-mail gestuurdControleer uw inbox",
        errorPasswordRequired: "Wachtwoord en wachtwoord bevestigen mag niet leeg zijn",
    },
    signUp: {
        note: "Meld u aan om uw gegevens op te slaan voor toekomstig gebruik",
        passwordNote: " 'Uw wachtwoord moet minimaal 8 tekens lang zijn en een hoofdletter: een kleine letter en een cijfer bevatten.'",
        fullName: "Volledige naam",
        country: "Land",
        region: "Regio",
        email: "E-Mail",
        mainInterest: "Belangrijkste interesse",
        expertise: "Expertise",
        password: "Wachtwoord",
        confirmPassword: "Wachtwoord bevestigen",
        iAccept: "Ik aanvaard",
        termsAndConditions: "de algemene voorwaarden van Haifa",
        and: "en",
        privacyPolicy: "Privacybeleid",
        next: "Volgende",
        emailSent: "We hebben een e-mail gestuurd naar {0}Controleer uw inbox",
        didntGet: "Niet ontvangen",
        checkBoxError: "Gelieve goed te keuren",
    },
    validationErrors: {
        fieldIsRequired: "Verplichte velden moeten worden ingevuld",
        incorrectEmailFormat: "E-mailadres bestaat niet",
        passwordValidation: "Ongeldig wachtwoord",
        passwordsDontMatch: "Wachtwoorden komen niet overeen",
        lettersOnly: "Gelieve alleen letters te gebruiken",
        incorrectEmail: "Onjuist e-mailadres",
        IncorrenctPassword: "Onjuist wachtwoord",
        emailExisted: "E-mailadres bestaat al in het systeem",
        termsCheckbox: "Verplicht",
        valueOutOfRange: "Waarde moet tussen {0} en {1} liggen",
        invalidDateFormat: "Gelieve een correcte datum in te voeren",
        dateMustBeGreater: "Oogstdatum moet later zijn dan plantdatum",
        dateMustBeAtLeastTwoMonths: "De datum moet minimaal twee maanden zijn",
        noServiceForSpecificCountry: "Er wordt geen service geleverd voor het geselecteerde land",
        dateMaxDatesTwelveMonth: "Het maximum is een jaar.",
    },
    errorMessages: {
        generic: "Er is een fout opgetreden: probeer het later opnieuw",
        LOGIN_FAILED: "De gebruikersnaam of het wachtwoord is niet correct",
        MISSING_EMAIL: "E-mail is vereist.",
        EMAIL_INVALID: "Onjuist e-mailadres",
        DUPLICATEUSERNAME: "Dit e-mailadres bestaat al in het systeem",
        PASSWORD_INVALID: "Ongeldig wachtwoord",
        USERNAME_INVALID: "Naam mag geen speciale tekens of cijfers bevatten",
        SPECIALIZATION_INVALID: "Ongeldige specialisatie",
        MAIN_INTEREST_INVALID: "Ongeldige belangrijkste interesse",
        REGION_INVALID: "Regio ongeldig",
        REGION_NOT_EXIST: "Regio bestaat niet",
        USER_NOT_FOUND: "Gebruiker bestaat niet",
        USER_ALREADY_EXIST: "Gebruiker bestaat al",
        MISSING_VALUES_TO_CONFIRM_REGISTRATION: "Registratie mislukt - er ontbreken waarden",
        EMAIL_SENT_TO_USER: "E-mail werd verzonden naar gebruiker",
        REGISTRATION_FAILED: "Registratie mislukt",
        TOKEN_INVALID: "Verificatie ongeldig",
        EMAIL_CONFIRMED_ALREADY: "Emailadres is al bevestigd",
        NO_SOLUTION_MATCH: "Er is geen klan-en-klare oplossing gevonden",
        EMAIL_CONFIRMED_SUCCESS: "Uw emailadres is succesvol bevestigd",
        VALIDATION_FAILED: "Validatie is mislukt",
        ACCEPT_TERMS_INVALID: "Ongeldige waarde voor voorwaarden aanvaarden",
        SAVING_ITEM_FAILED: "Kan artikel niet opslaan",
        SAVED_ITEM_NOT_FOUND: "Artikel bestaat niet",
        UPDATING_RECIPE_ITEM_FAILED: "Kan artikel niet bijwerken",
        REMOVING_RECIPE_ITEMS_FAILED: "Kan item recept niet wissen",
        REMOVING_GRAPH_ITEMS_FAILED: "Kan item grafiek niet wissen",
        ITEM_UPDATED_SUCCESSFULLY: "Artikel is succesvol bijgewerkt",
        ITEM_DELETED_SUCCESSFULLY: "Artikel is succesvol gewist",
        RAW_MATERIAL_PARAMETERS_NOT_VALID: "Kan nieuwe grondstof niet opslaan - Ongeldige parameters",
        SAVING_RAW_MATERIAL_FAILED: "Kan nieuwe grondstof niet opslaan",
        RAW_MATERIAL_ALREADY_EXIST: "Grondstof bestaat al",
        REMOVING_ITEM_FAILED: "Kan artikel niet wissen",
        UPDATING_ITEMS_FAILED: "Fout bij bijwerken artikel in DB",
        CALCULATOR_IS_NOT_READY: "Gegevens worden geladen…..",
        NUTRIENT_TYPE_INVALID: "Type nutriënt ongeldig",
        BLEND_INVALID: "Ongeldige Multicote-mengsel",
        TYPE_INVALID: "type ongeldig voor een van de eigenschappen",
        MISSING_SAVED_ITEM_ID: "Opgeslagen artikel-ID ontbreekt in verzoek",
        ITEM_NOT_FOUND: "Artikel niet gevonden",
        RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "Recept kan niet meer dan 6 grondstoffen bevatten",
        RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
            "Recept moet minimaal één gecoate grondstof en maximaal 5 ongecoate materialen bevatten",
        ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Een of meer ongeldige grondstof-ID`s in recept",
        PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "Blendpercentage moet 100% zijn",
        START_DATE_REQUIRED: "Startdatum vereist",
        END_DATE_REQUIRED: "Einddatum vereist",
        END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "Einddatum moet later zijn dan startdatum",
        YIELD_VALUE_REQUIRED: "Opbrengst vereist",
        COUNTRY_INVALID: "Land ongeldig",
        CROP_CODE_INVALID: "Gewas ongeldig",
        MESUREMENTS_INVALID: "Meeteenheid ongeldig",
        SOIL_AND_WATER_COMBINATION_INVALID: "Combinatie bodem en water ongeldig",
        MONTHS_AND_TEMPATURES_INVALID: "Waarden voor maanden en temperaturen ongeldig",
        shareWithNoSaving: " 'sorry: kan niet-opgeslagen artikel niet delen'",
        ITEM_NAME_TOO_SHORT: "naam te kort",
        ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED",
        ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED",
        UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",
    },
    rightDrawer: { showMoreText: "Tonen" },
    fmSummary: {
        shortSummaryTitle1: "Gewassen",
        shortSummaryTitle2: "Bodem",
        shortSummaryTitle3: "Oplossing",
        shortSummaryTitle4: "Bedrijf",
        shortSummaryTitleGraphPage: "Aanpassen",
        ourProducts: "Onze producten",
        summary: "Verzamelde gegevens",
        seeMoreProducts: "Bekijk meer Multicote™-producten",
        recipeCoatedElements: "Gecoate elementen",
        recipeUncoatedElements: "Ongecoate elementen",
    },
    fmLeftMenu: {
        title: "MultiMatch",
        subTitle: "Op maat gemaakte voedingsprogramma`s\nvoor planten",
        menuLabels: {
            label0: "Shlomit Adary",
            label1: "Multicote Agri-oplossing",
            label2: "Multicote-oplossing",
            label3: "Opgeslagen artikelen",
            label4: "Over",
            label5: "Neem contact met ons op",
        },
        logout: "Uitloggen",
    },
    steps: {
        cropsDesktop: "Gewassen",
        cropsMobile: "Eigenschappen van uw gewas",
        soilDesktop: "Bodem",
        soilMobile: "Bodemtemperaturen en -eigenschappen",
        resultsDesktop: "Resultaten",
        resultsMobile: "Resultaten",
        farmDesktop: "Boerderij(Facultatief)",
        farmMobile: "Boerderijpraktijk (Facultatief)",
        customizeDesktop: "Aanpassen(Facultatief)",
        customizeMobile: "Stel uw eigen mengsel samen (Facultatief)",
    },
    agriSolution: {
        title: "Multicote Agri-oplossing",
        selectCropLabel: "Kies uw gewas",
        expectedYieldLabel: "Verwachte opbrengst",
        plantingDateLabel: "Plantdatum",
        finalHarvestExpectedDate: "Verwachte uiterste oogstdatum",
        selectPlotLocationLabel: "Kies perceellocatie",
        selectPlotLocationNote: "Wees zo specifiek mogelijk. Dit helpt om de klimaatgegevens te evalueren",
        selectArea: "of kies een gebied",
        selectOrAddNew: "Kies uit de lijst of voeg nieuwe toe",
        onTheMap: "op de kaart",
        select: "Kiezen",
        selectSoilLabel: "Bodemtemperaturen en -eigenschappen",
        waterRegime: {
            title: "Kies waterregime",
            description: "Wat zijn de neerslagomstandigheden in het gebied?",
            sliderMarks: {
                "1": "Droog",
                "2": "Halfdroog",
                "3": "Subtropisch",
                "4": "Tropisch",
            },
        },
        soilType: {
            title: "Kies bodemtype",
            description: "Wat is het bodemtype van het perceel?",
            sliderMarks: {
                "1": "Zand, leemachtig zand",
                "2": "Half-zandig",
                "3": "Slib, zilte leem, zilte klei",
                "4": "Leem, klei",
            },
        },
        soilWarning:
            "De Nutriëntenbehoefte is gebaseerd op de verwachte opbrengst. Het Multicote bemestingsprogramma is ontworpen om het gewas optimaal te voorzien van alle macronutriënten. De bodem wordt beschouwd als buffer en er wordt geen rekening gehouden met het nutriëntengehalte in de bodem. Het is echter een goede landbouwpraktijk om iedere 2 tot 3 jaar grondmonsters te nemen. Indien van toepassing kan op de analyse resultaten worden gestuurd om de bodemvruchtbaarheid te behouden of te verbeteren.",
    },
    fmDescriptionSnippet: {
        title: "Welkom bij de `Multicote Calculator",
        description:
            "Een cloudgebaseerde software om in een paar eenvoudige stappen uw eigen: op maat gemaakte bemestingsplan (CRF) te creëren voor individuele of zakelijke telers",
    },
    fmDropdownWithImg: { title: "Kies uw gewas" },
    back: "Terug",
    fmRecommendedProduct: {
        volume: "Aanbevolen toepassingsvolume",
        method: "toepassingsmethode",
        link: "Klik voor een grafiek afgiftepatroon",
    },
    pageStep1: {
        soilTemp: "Kies de bodemtemperatuur",
        change: "Wijzigen",
        note: "Kies uw gewas uit de lijst en vul uw verwachte opbrengst: plantdatum en uiterste oogstdatum in.",
    },
    fertilizationPopup: {
        title: "Toepassing bemestingsnutriënt",
        subTitle: "Kent u uw huidige totale nutriëntengehalte volgens uw huidige bemestingsplan?",
        thirdTitle: "Kies `Ik weet het` hieronder om uw nieuwe op maat gemaakte formule te berekenen",
        iKnow: "Ik weet het",
        iDontKnow: "Ik weet het niet",
        next: "Volgende",
    },
    saveProcessPopup: {
        title: "Dit proces opslaan",
        subTitle: "We merken dat uw proces niet is opgeslagen: wilt u doorgaan?",
        dontShowThisMessage: "Dit niet meer tonen",
        noThanks: "Nee: bedankt",
        save: "Opslaan",
    },
    clearStepPopup: {
        title: "Deze stap wissen",
        subTitle: "Weet u zeker dat u uw gegevens uit deze stap wilt wissen?",
        dontShowThisMessage: "Dit niet meer tonen",
        noGoBack: "Ga terug",
        clear: "Mijn gegevens wissen",
    },
    deleteItemPopup: {
        title: "Artikel verwijderen",
        subTitle: "Weet u zeker dat u dit artikel wilt verwijderen?",
        no: "Nee",
        yes: "Ja",
    },
    saveItemPopup: {
        title: "Oplossing opslaan",
        label1: "Naam oplossing",
        label2: "Gebied",
        getBack: "Ik zou graag willen dat een agronoom van Haifa mijn selectie beoordeelt en contact met mij opneemt",
        save: "Opslaan",
        snackbar: "Artikel opgeslagen",
    },
    pageStep4: {
        title: "Veldpraktijk",
        table: {
            nutrients: "Nutriënten",
            nutrientsUnit: "(Kg/Ha)",
            label1: "Landbouwmethode",
            label2: "Gewasbehoefte",
            label3: "Opgeslagen nutriënten uit de omgeving",
        },
        question: "Hoe doet u het in de praktijk?",
        questionDescription:
            "Als u al bepaalde meststoffen gebruikt die een normale opbrengst opleveren: geef ons dan de totale NPK die per seizoen is toegepast. We gebruiken deze cijfers om de optimale Multicote-verhoudingen voor uw aangepaste formule te berekenen.",
        fill: "Voer uw praktijk in",
        buttomDescription:
            "Door het gebruik van Multicote wordt de gebruiksefficiëntie van de gecoate nutriënten sterk verbeterd. Hierdoor kunnen we het totaal aan nutriënten verminderen en daarmee de uitspoeling naar het grondwater en de opbouw van ongewenste zoutconcentraties in de bodem verminderen.",
        warningText1: "Wij adviseren om contact op te nemen met een",
        warningText2: "professionele agronoom of distributeur van Haifa",
        warningText3: "om uw selectie te bevestigen vooraleer toe te passen.",
        clearThisStep: "Deze stap wissen",
        next: "Volgende",
        save: "Opslaan",
    },
    multicoteTable: { mesurmentUnit: " (%)" },
    mainInterests: { OFA: "Openveldlandbouw", N: "Kwekerij" },
    metricMethods: { "1": "Metriek", "2": "Imperiaal" },
    specialties: {
        "1": "Tuinieren \\ hobby",
        "2": "Teler",
        "3": "Landbouwaannemer",
        "4": "Landbouwtraining \\ services",
        "5": "Handel",
        "6": "Andere",
    },
    PageReleaseChart: {
        greenMessage: {
            title1: "HOE TE GEBRUIKEN",
            description1: "Doseer Multicote altijd  bij de wortelzone.",
            description2: "Voor optimale prestaties moet het worden afgedekt met aarde of een bodembedekker.",
            subTitle: "Beste methode:",
            description3: "In rijen aanbrengen tijdens het zaaien. Tweede beste: Voor de teelt gelijkmatig verdelen en de Multicote in het zaaibed verwerken.",
            title2: "WANNEER",
            description4: "Tijdens het zaaien of bij de voorbereiding van het perceel: maar niet meer dan 2 weken voor het planten.",
            title3: "HOEVEEL",
            description5: "Multicote is veilig voor gebruik: maar zorg ervoor dat de machines correct zijn gekalibreerd.",
            title4: "AFGIFTECURVE",
            description6: "De afgiftecurve geeft de afgifte van nutriënten weer volgens de verwachte bodemtemperatuur",
            radioButtonLabel: "Kies een thema",
            shareUnsavedItem: "sorry: kan niet-opgeslagen artikel niet delen",
        },
        currentDayRemainingReleaseValues: {
            preValue: "Maand",
            postValue: "resterende NPK:",
            currentPrecentage: "Remaining NPK (Percentage):",
            Percentage: "(Percentage)",
        },
        sendToAgronomist: {
            preUserName: "De gebruiker",
            preCrop: "plant een oplossing voor het gewas",
            preYield: "met een verwachte opbrengst van",
            preStartingDate: "Begindatum:",
            preFinalDate: "Uiterste datum:",
            preSolutionName: "Oplossing:",
            materialCode: "Material code:",
            preVolumeApplication: "Volumetoepassing",
        },
        warning: {
            description: "Er zal een bijkomend advies van secundaire en micro-elementen nodig zijn. Voor een volledige aanbeveling",
            boldDescription: "gelieve contact op te nemen met uw plaatselijke Haifa-adviseur of -distributeur",
        },
        buttons: {
            downloadFile: "PDF downloaden",
            sendToPro: "Verzenden naar adviseur",
            shareLink: {
                desktop: "Link delen",
                mobile: "delen",
            },
        },
    },
    wideTable: {
        kodkod: { title1: "Materiaalafgifte", title2: "per maand (Kg/Ha)" },
        sideLabel: { label1: "N (var)", label2: "P", label2_1: "O", label3: "K" },
        months: {
            month1: "Jan",
            month2: "Feb",
            month3: "Maart",
            month4: "Apr",
            month5: "Mei",
            month6: "Jun",
            month7: "Jul",
            month8: "Aug",
            month9: "Sep",
            month10: "Okt",
            month11: "Nov",
            month12: "Dec",
        },
        caroselHeader: { title: "Afgifte per maand (%)" },
        next: "Volgende",
        back: "Terug",
    },
    saveItemsPage: {
        title: "Opgeslagen oplossingen",
        inputPlaceholder: "Voer een gewastype of een gebied in om uw opgeslagen mengsels te vinden",
        mobile_inputPlaceholder: "Voer een gewastype of een gebied in",
        clearAll: "Alles wissen",
        loadMore: "Meer laden",
        savedItemCard: {
            rename: "Naam wijzigen",
            delete: "Wissen",
            duplicate: "Dupliceren",
            contact: "Contact",
            showTo: "Toon artikel aan Haifa-adviseur",
        },
    },
    multicoteSolutionPage: {
        stepOne: {
            firstInput: "Mengsel kiezen",
            secondInput: "Begindatum",
            radioLabel1: "P2O5 K20",
            radioLabel2: "PK",
            selectTemperature: "Temperatuur kiezen",
            calculateButton: "Berekenen",
            setTempratureButton: "Temperaturen instellen",
        },
        title: "Multicote Advies",
        changeCalculationSetting: "Berekeningsinstelling wijzigen",
        save: "Opslaan",
        line: "Lijn",
        bar: "Bar",
        graphCodCodTitle: "Materiaalafgifte",
    },
    pageStep3: {
        carbonFootprintButtonText: "Calculate Carbon Footprint",
        subTitle: "Uw advies",
        customize: {
            bestSuit: "Meest geschikte formule",
            subDescription: "We hebben geconstateerd dat deze formule het beste aansluit bij de behoeften van uw gewas",
            title: "Wilt u de formule aanpassen?",
            secondSubDescription:
                "U kunt deze formule in een paar eenvoudige stappen aanpassen of uw eigen formule samenstellen om aan te sluiten bij uw plaatselijke omstandigheden",
            button: "Formule aanpassen",
            topLink: "Afgiftegrafiek",
        },
        bottomTitle: "Kant-en-klare formule",
        bottomDescriptionWithMatch: "Deze kant-en-klare formule sluit het nauwst aan bij uw aanbeveling",
        bottomDescriptionWithoutMatch: "We konden geen passende formule vinden die past bij uw gewasbehoefte: bodem en klimaatomstandigheden",
        recommendedProduct: {
            description:
                "Ons advies is enkel gebaseerd op de gewasbehoefte voor NPK: volgens de bekende vraag naar deze nutriënten. Secundaire en micronutriënten worden toegepast op basis van de bodemanalyse en gewasbehoeften.",
        },
        save: "Opslaan",
        inSoil: "In de bodem",
        metric: "Kg/Ha",
        imperial: "ST/Acre",
    },
    pageStep5: {
        title: "Stel uw eigen mengsel samen",
        updateButton: "N, P, K-berekening bijwerken",
        recipeValidationError: "Recept dient minimaal 1 gecoate grondstof te bevatten en maximaal 6 ingrediënten",
        save: "Opslaan",
        bestSolution: "Beste oplossing",
        subTitle1: "Kies maximaal 6 grondstoffen in totaal",
        coated: "Gecoat",
        uncoated: "Ongecoat",
        completePercentage: "Percentage gecoat in Multicote mengsel:",
        missing: "ontbreekt",
        clear: "Deze stap wissen",
        continueButton: "Doorgaan naar Afgiftegrafiek",
        bottomDrawer: {
            savedItem: "Opgeslagen artikel",
            rename: "Naam wijzigen",
            delete: "Wissen",
            reset: "Resetten",
            update: "Bijwerken",
        },
        uncoatedHelperText: "",
        updateCard: {
            leftSpan: "N, P, K wordt berekend op basis van uw grondstoffenkeuze",
            errorMessage: {
                missingWord: "Increase",
                extraWord: "Decrease",
                rightPart: "% for calculation",
            },
        },
    },
    userAreaPage: {
        title: "Mijn profiel",
        tab1: "Gebruikersprofiel",
        tab2: "Mijn grondstoffenbank",
        inputLabel1: "Volledige naam",
        inputLabel2: "Land",
        inputLabel3: "E-Mail",
        inputLabel4: "Uw belangrijkste interesse",
        inputLabel5: "Expertise (Optioneel)",
        button: "Bijwerken",
        inputSecondPage: "Ongecoat",
        messages: { success: "Profiel werd succesvol bijgewerkt" },
        uncoatedInputHelperText: "",
    },
    contactUs: {
        title: "Heeft u een vraag? Wilt u overleggen?",
        secondTitle: "bedankt voor uw bezoek aan ons platform",
        description: "We helpen u graag met al uw vragen en horen graag over uw ervaringen: zodat we ons aanbod kunnen blijven verbeteren.",
        inputLabel1: "Land",
        inputLabel2: "Regio",
        inputLabel3: "Positie",
        inputLabel4: "Kweekmethode",
        inputLabel5: "Mobiel nummer",
        inputLabel6: "Oppervlakte (ha)",
        inputLabel7: "E-mailadres",
        inputLabel8: "Uw bericht",
        back: "Terug",
        send: "Verzenden",
        messages: {
            success: "Bedankt voor uw e-mail; u hoort spoedig van ons.",
            invalidPhoneNumber: "Ongeldig mobiel nummer",
        },
    },
    PDFfile: {
        mateData: {
            createdBy: "Gemaakt door:",
            name: "Naam:",
            location: "Plaats:",
            phoneNumber: "Telefoonnummer:",
            Date: "Datum:",
            Time: "Tijd:",
        },
        summaryData: {
            nutrientsApplied: "Toegepaste nutriënten :",
            collectedDataTitle: "Verzamelde gegevens:",
            cropsTitle: "Gewassen",
            cropProp: "Gewas",
            yieldProp: "Opbrengst",
            plantingDateProp: "Plantdatum",
            harvestDateProp: "Oogstdatum",
            soilTitle: "Bodem",
            WaterRegimeProp: "Waterregime",
            soilProp: "Bodem:",
            customizedTitle: "Aangepast",
            recipeCoatedTitle: "Gecoate elementen",
            recipeUncoatedTitle: "Ongecoate elementen",
            recommended: "Aanbevolen",
            MaterialCodeProp: "Materiaalcode",
        },
        waver: {
            title: "VRIJSTELLING",
            body: {
                before: "De teler dient voor gebruik vast te stellen of het product geschikt is voor het beoogde gebruik.",
                theGrower: "De teler neemt alle risico`s en aansprakelijkheid voor gevolg- en incidentele schade op zich. `Dit product",
                isSold: "wordt verkocht zonder enige vorm van garantie, expliciet of impliciet, met betrekking tot de verkoopbaarheid",
                orFitness: " of geschiktheid voor een bepaald doel.",
                caution: "Voorzichtig: ",
                harmful: "Schadelijk bij inslikken; buiten bereik van kinderen houden. Koel en droog bewaren.",
            },
        },
        descriptionRecommended:
            "Ons advies is enkel gebaseerd op de gewasbehoefte voor NPK: volgens de bekende vraag naar deze nutriënten.\nSecundaire en micronutriënten worden toegepast op basis van bodemanalyse en gewas behoeften.",
        howToUse: {
            title: "HOE TE GEBRUIKEN",
            body: {
                firstLine: "Breng Multicote altijd aan in de wortelomgeving.",
                secondLine: "Voor optimale prestaties moet het worden afgedekt met een paar centimeter aarde",
                thirdLine: "oder Mulch.",
                fourthLinePartOne: "Beste methode:",
                fourthLinePartTwo: "In rijen aanbrengen tijdens het zaaien.",
                fifthLinePartOne: "Tweede beste:",
                fifthLinePartTwo: "Voor de teelt gelijkmatig verdelen en de Multicote™",
                fifthLinePartThree: "in het zaaibed verwerken.",
                forOptimalPerformance: "Meng Multicote™ voor het planten met potgrond voor optimale prestaties.",
                mixMulticote: " Meng Multicote™ met potgrond voordat u gaat planten.",
                secondBestPractice: "Tweede best methode - Dibbelen:",
                forLate: "Maak bij een late toepassing gaten rond de plant en breng Multicote™ aan",
                evenly: "gelijkmatig afdekken met grond.",
            },
        },
        when: {
            title: "WANNEER",
            body: {
                firstLine: "Tijdens het zaaien of bij de voorbereiding van het perceel, maar niet meer dan 2 weken voor het ",
                secondLine: "planten.",
            },
        },
        howMuch: {
            title: "HOEVEEL",
            body: {
                firstLine: "Multicote™ is veilig voor gebruik, maar zorg ervoor",
                secondLine: "dat de machines correct zijn gekalibreerd.",
            },
        },
        releaseCurve: {
            title: "AFGIFTECURVE",
            body: "De afgiftecurve geeft de afgifte van nutriënten weer volgens de verwachte bodemtemperaturen",
        },
        nameOfFile: "Multicote™ - Onze oplossing.pdf",
    },
    ShareEmail: {
        title: "Instructies ",
        body: {
            please: "Gelieve",
            find: "in bijlage",
            attached: "een aanbeveling",
            recommendation: "te vinden",
            Thank: "Met",
            you: "dank",
            Haifa: "Haifa",
            Group: "Group",
        },
    },
    autoCompleteInput: {
        firstSpan: "Deze waarden zijn ongeldig",
        secondSpan: "max N: P: K is 46: 54: 62",
        thirdSpan: "Max. totaal is 66",
        noOptions: "Geen opties",
    },
    sideMenu: {
        termsAndCondition: {
            title: "Algemene voorwaarden",
            contentTitle: "Gebruiksvoorwaarden",
        },
        privacyPolicy: { title: "Privacybeleid" },
        copyRightTitle: "Auteursrecht 2021 Haifa",
        poweredBy: "Mogelijk gemaakt door",
    },
};
export default texts;
